import { Injectable } from '@angular/core';
import { PageRequest } from '../models/page-request';

@Injectable({
  providedIn: 'root',
})
export class HistoryService {
  public popHistory(event: any): PageRequest | null {
    let pageRequest: PageRequest | null = null;
    pageRequest = event.state;
    return history.state;
  }

  public pushHistory(request: PageRequest) {
    history.pushState(request, '', document.location.href);
  }

  public replaceHistory(request: PageRequest) {
    history.replaceState(request, '', document.location.href)
  }
}
